import { City, Setor, State } from '@shared/models';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ConsultRequest } from '@shared/utils/consult-request';
import * as toastr from 'toastr'

import { ClientesService } from '@modules/clientes/services/clientes.service';

@Component({
  selector: 'app-bairro-combo',
  templateUrl: './bairro-combo.component.html',
  styleUrls: ['./bairro-combo.component.css']
})
export class BairroComboComponent implements OnInit {

  @Input() bairro: string = null;
  @Output() bairroChange = new EventEmitter<string>();

  _setor: Setor = null;
  _cidade: City = null;

  @Input() required = false;
  @Input() disabled = false;

  districtsRequest = new ConsultRequest<string[]>();

  constructor(
    private clientService: ClientesService,
  ) {
  }

  @Input()
  set setor(value: Setor | null){
    if(!value){
      this._setor = null;
    }else{
      this._setor = value;
    }

    this.getDistricts();
  }

  get setor(){
    return this._setor;
  }

  @Input()
  set cidade(value: City | null){
    if(!value){
      this._cidade = null;
    }else{
      this._cidade = value;
    }

    this.getDistricts()
  }

  get consultDisabled(){
    return !this.setor || !this.cidade || this.districtsRequest.isLoading;
  }

  get cidade(){
    return this._cidade;
  }

  ngOnInit() {
  }

  handleDistrictChange(){
    this.bairroChange.emit(this.bairro)
  }

  handleClick(event: MouseEvent){
    if(this.consultDisabled){

      event.preventDefault()

      if(this.districtsRequest.isLoading){
        toastr.error('A combo ainda está carregando, tente mais tarde')
        return;
      }

      toastr.error('Para selecionar o bairro, selecione a cidade antes')
      return;
    }

  }

  // metodos privados

  private getDistricts() {
    this.reset();

    if(this.consultDisabled){
      return;
    }

    this.districtsRequest.get(
      this.clientService.getDistricts(this.cidade.idMunic, this.setor.id)
    )
  }

  private reset(){
    this.districtsRequest.reset()
    this.districtsRequest.cancel()
    this.bairro = null;
    setTimeout(()=>this.handleDistrictChange())
  }

}
